import React from "react";
import Award from "../assets/img/custom/badge.png";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";

const SeasonalPreview = (props) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      <Row className="p-3 gx-0 mx-0">
        <Col xl="5" lg="5" md="5" sm="5" xs="8" className="p-0">
          <div className="position-relative ml-3">
            <img src={Award} alt="" width={100} />
            <small className="position-absolute preview-year">
              <small className="d-flex justify-content-center flex-column text-nowrap ">
                {props.data?.year} <span>season</span>
              </small>
            </small>
            <p className="position-absolute preview-game text-uppercase">
              {props.data?.sport}
            </p>
          </div>
        </Col>
        <Col xs="2" sm="1" md="1" lg="1" xl="1" className="p-0 ml-0">
          <small>
            {props.data?.type === "X"
              ? props.data?.eventPlus?.substring(0, 4)
              : props.data?.type?.substring(0, 4)}

            <span className="txt">{props.data.sportType}</span>
            {props.data?.listNumber}
          </small>
        </Col>
        <Col xs="2" sm="2" md="2" lg="2" xl="1" className="p-0">
          <div>
            <p className="txt2">
              {props.data?.typeData1 ? props.data?.typeData1 : "type Data"}
            </p>
          </div>
        </Col>
        <Col
          xs="12"
          sm="4"
          md="4"
          lg="4"
          xl="5"
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <h6 className="mt-2 ml-0"> ID #{user?.athleteID}</h6>
          <img src={user?.player_image?.url} width={100} alt="" />
          <div>
            {props?.data?.qrCode && (
              <img
                src={
                  props?.data?.qrCode instanceof File
                    ? URL.createObjectURL(props?.data?.qrCode)
                    : props?.data?.qrCode
                }
                width={100}
                alt=""
                className="mb-3"
              />
            )}
          </div>
        </Col>
      </Row>
      <Col xs="12" xl="12">
        <div className="text-center">
          <p className="p-1 preview-bottom-text mb-1 m-0">
            {props.data?.typeData2 ? props.data?.typeData2 : "Type data"}
          </p>
          <p className="p-1 preview-bottom-text m-0">
            {props.data?.typeData3 ? props.data?.typeData3 : "Type data"}
          </p>
          <span className="text-center">
            {" "}
            {user?.first_name + " " + user?.last_name}
          </span>
          {props.data.qrPrice ? (
            <h2 className="text-center">{props?.data.qrPrice}</h2>
          ) : (
            <h2 className="text-center">{props?.data?.bought}</h2>
          )}
        </div>
      </Col>
    </>
  );
};

export default SeasonalPreview;
